/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { SALARY_REPORT_STATE } from "./salary-report-constant";
const useSalaryReportService = () => {
    const [salaryReportTableUILoading, setSalaryReportTableUILoading] = useState(false);
    const [salaryReportListData, setSalaryReportListData] = useState([]);
    const [salaryReportPDFData, setSalaryReportPDFData] = useState([]);
    const [salaryReportSummary, setSalaryReportSummary] = useState({})
    const [organizationInfo, setOrganizationInfo] = useState({})
    const { fetchData } = useAPIHandler()
    const [allowances, setAllowances] = useState([])
    const [salaryReportInputs, setSalaryReportInputs] = useState(SALARY_REPORT_STATE)
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("")
    const currentRoute = location.pathname.split('/').pop();
    const [loadingAllSalaryReport, setLoadingAllSalaryReport] = useState(false);
		const [dataFetched, setDataFetched] = useState(false);
    const [departmentLists,setDepartmentLists] = useState([])
    const [deptId, setDeptId] = useState('')
    const [totalEmployee, setTotalEmployee] = useState(0)

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setSalaryReportInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    const extractAllowances = (data) => {
        const allAllowances = data.reduce((acc, salary) => {
            salary.allowance.forEach(allowance => {
                if (!acc.includes(allowance.allowance_name)) {
                    acc.push(allowance.allowance_name);
                }
            });
            return acc;
        }, []);
        setAllowances(allAllowances)
    }
    const { report_month } = salaryReportInputs;
    let year, month
    if (report_month) {
        const parts = report_month.split("-");
        year = parts[0];
        month = parts[1];
        if (month.startsWith("0")) {
            month = month.substring(1);
        }
    }
    const fetchAllSalaryReportEmpList = async () => {
        setSalaryReportTableUILoading(true);
        try {
            if (report_month) {
                const url = currentRoute === "salary-wages-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
                    :
                    currentRoute === "salary-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&salary_type=salary`
                        :
                        currentRoute === "wages-report" ? `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}&salary_type=wages`
                            :
                            `/report/salary?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`

                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setSalaryReportListData(response?.data?.salary);
                setTotalPages(response?.data?.pagesNumber);

            }
            setSalaryReportTableUILoading(false)
        } catch {
            setSalaryReportTableUILoading(false)
        }
    }
    const fetchAllSalaryReportData = async () => {
        setLoadingAllSalaryReport(true);
        try {
            if (report_month) {
                const url = currentRoute === "salary-wages-report" ? `/report/salary?month=${month}&year=${year}&order_type=ASC&dept_id=${deptId}`
                    :
                    currentRoute === "salary-report" ? `/report/salary?month=${month}&year=${year}&salary_type=salary&order_type=ASC&dept_id=${deptId}`
                        :
                        currentRoute === "wages-report" ? `/report/salary?month=${month}&year=${year}&salary_type=wages&order_type=ASC&dept_id=${deptId}`
                            :
                            `/report/salary?month=${month}&year=${year}&order_type=ASC&dept_id=${deptId}`

                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setSalaryReportPDFData(response?.data?.salary);
                extractAllowances(response?.data?.salary);
                setSalaryReportSummary(response?.data?.additional_details)
                setTotalEmployee(response?.data?.count)
                setOrganizationInfo(response?.data?.org_details)
								setDataFetched(true)
                logger.log(response, "salaryReportListData99")

            }
            setLoadingAllSalaryReport(false)
        } catch (error){
            setLoadingAllSalaryReport(false)
        }

    }
    const fetchDepartmentList = async () => {
        try {
            const response = await fetchData({
                url: '/department',
                method: 'GET',
            });
    
            const formattedData = response?.data?.departments?.map(dept => ({
                id: dept.department_id,
                name: dept.deptName
            }));
    
            setDepartmentLists(prev => [
                { id: '', name: 'All Employee' },  
                { id: null, name: 'Unassigned Employee' },  
                ...(formattedData || [])
            ]);
    
        } catch (error) {
            logger.log(error, "Error fetching department list");
            setDepartmentLists([
                { id: '', name: 'All Employee' },  
                { id: null, name: 'Unassigned Employee' }
            ]); 
        }
    };
    
    

    useEffect(() => {
        fetchAllSalaryReportEmpList();
        fetchDepartmentList()
    }, [salaryReportInputs, rowsPerPage, currentPage, searchQuery])
    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    return {
        salaryReportListData,
        allowances,
        salaryReportSummary,
        organizationInfo,
        salaryReportInputs,
        handleChange,
        rowsPerPage,
        currentPage,
        totalPages,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        searchQuery,
        setSearchQuery,
        departmentLists,
        salaryReportPDFData,
        fetchAllSalaryReportData,
        loadingAllSalaryReport,
        dataFetched,
        setDeptId,
        totalEmployee
    }
}

export default useSalaryReportService
